export default [
    {
        path: '/Hbhousing',
        name: 'Hbhousing',
        component: () => import('@/views/pages/Hbhousing/HbhousingContractInput.vue'),
        meta: {
          pageTitle: '住商資料暫存',
          breadcrumb: [
            {
              text: '住商資料暫存',
              active: true,
            },
          ],
          keepAlive: true // 需要被缓存
  
        },
      },
  ]